import React, { useState } from 'react';
import HeroSection from '../components/HeroSection';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const [showPopup, setShowPopup] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  return (
    <div style={{ position: 'relative', minHeight: 'calc(100vh - 72px)' }}>
      <AnimatePresence>
        {showPopup && (
          <motion.div
            initial={{ opacity: 0, scale: 0.5, rotate: -360 }}
            animate={isHovered
              ? { opacity: 1, scale: 1.12, rotate: 0 }
              : { opacity: 1, scale: [1, 1.07, 1], rotate: 0 }
            }
            transition={isHovered
              ? { type: 'spring', damping: 12, stiffness: 200 }
              : { scale: { duration: 2.2, repeat: Infinity, ease: 'easeInOut' }, opacity: { duration: 0.5 }, rotate: { type: 'spring', damping: 20, stiffness: 100 } }
            }
            exit={{ opacity: 0, scale: 0.5, rotate: 180 }}
            style={{
              position: 'absolute',
              top: '8%',
              right: '4%',
              zIndex: 50,
              width: 'clamp(100px, 18vw, 160px)',
              height: 'clamp(100px, 18vw, 160px)',
              backgroundColor: '#ea580c',
              clipPath: 'polygon(50% 0%, 100% 100%, 0% 100%)',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'center',
              paddingBottom: 'clamp(12px, 3vw, 22px)',
              cursor: 'pointer',
              boxShadow: '0 20px 25px -5px rgba(234,88,12,0.4), 0 10px 10px -5px rgba(234,88,12,0.2)',
            }}
            onClick={() => navigate('/wildlife')}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            whileTap={{ scale: 0.9 }}
          >
            <div style={{
              color: 'white',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: 'clamp(0.55rem, 2vw, 0.85rem)',
              maxWidth: '90%',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px',
              userSelect: 'none'
            }}>
              <span>Explore our</span>
              <span>travel services</span>
              <button
                onClick={(e) => { e.stopPropagation(); setShowPopup(false); }}
                style={{
                  background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)',
                  fontSize: 'clamp(0.5rem, 1.5vw, 0.75rem)', cursor: 'pointer', marginTop: '6px', textDecoration: 'underline'
                }}
              >
                Close
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <HeroSection />
    </div>
  );
};

export default Home;
